// import Popover from 'components/Popover';
import React, { MouseEventHandler } from 'react';
import messages from './Messages';
import AssigneeChip from 'components/AssigneeChip';
import { IProjectMemberOption, IRoleOption, IUserOption } from './UserSelector';
import { ChipProgress, Chip } from 'components/AssigneeChip/AssigneeChip';
import { connect, MapStateToProps } from 'react-redux';
import { RootState } from 'store/store';
import { convertNumbersToProperFormat } from 'utils/number';
import Icon from 'components/Icon';
import assignmentMessages from 'components/TaskListView/Messages';
import { IAssignmentHistory, ITask, TaskStatus } from 'store/tasks/tasksType';
import { IPermission } from 'store/entity/IPermission';
import { PopoverTriggerBy } from '../PopoverBase/types';
import { exactWhite, lightGray } from '../../utils/style/colors';
import { EditIcon } from './styles';
// import APopover from '../APopover/APopover';
import Popover from '../Popover/Popover';

type IOwnProps = {
  values: Array<IUserOption | IRoleOption>;
  singleChoice?: boolean;
  onFocus?: MouseEventHandler<HTMLDivElement>;
  disable?: boolean;
  emphasizeSelect?: string;
  task?: ITask;
  canChangeProgress?: boolean;
  canChangeSelfProgress?: boolean;
  permission?: IPermission;
  compact?: boolean;
  trigger?: PopoverTriggerBy;
  onChangeProgress?: (
    assigneeId: number,
    progress: string,
    status: TaskStatus,
    progressDescription: string,
    fieldValues: { [key: string]: string }
  ) => void;
  type: string;
  ref?: any;
  showTaskFields?: boolean;
  disablePopover?: boolean;
  onSetAssignmentHistory?: (assingmentHistory: IAssignmentHistory[]) => void;
  assigneeIdToShow?: number | null;
  onSetAssigneeIdToShow?: (asId: number | null) => void;
};
type IStateToProps = {
  thisUserId: number;
};
type ComponentProps = IOwnProps & IStateToProps;
const TaskUserList: React.FunctionComponent<ComponentProps> = ({
  compact,
  values,
  task,
  onChangeProgress,
  canChangeProgress,
  permission,
  type,
  trigger,
  thisUserId,
  canChangeSelfProgress,
  singleChoice,
  disable,
  ref,
  showTaskFields,
  onFocus,
  emphasizeSelect,
  disablePopover = false,
  onSetAssignmentHistory,
  assigneeIdToShow,
  onSetAssigneeIdToShow,
}) => {
  const sum = values.reduce(
    (sum: number, t: IUserOption | IRoleOption | IProjectMemberOption) => {
      return (sum += (t as IUserOption) ? (t as IUserOption)!.progress! : 0);
    },
    0
  );
  const total = values.length;
  const hasProgress = type !== 'noAssignment';
  return values.length < 2 || !compact || !!assigneeIdToShow ? (
    <div
      style={{
        display: values.length > 1 ? 'flex' : undefined,
        flexWrap: 'wrap',
        // maxHeight: '80vh',
        borderRadius: '10px',
        border: singleChoice ? `1px solid ${lightGray}` : '',
        minHeight: singleChoice ? '32px' : '',
        maxHeight: '20vh',
        overflow: values.length > 1 ? 'auto' : undefined,
        minWidth: singleChoice ? '100%' : '',
        width: '100%',
      }}
      ref={ref}
      onClick={singleChoice ? onFocus : undefined}
    >
      {values.map((chip?: IUserOption | IRoleOption | IProjectMemberOption) => {
        const userChip = chip as IUserOption;
        return type === 'noAssignment' ? (
          <Chip
            compact={compact}
            key={userChip.userId}
            hasProgress={false}
            showPointer={false}
            // onClick={this.handleShowPopover}
          >
            <span>
              {userChip.name}
              {userChip.relatedRoleName &&
                ' (' + userChip.relatedRoleName + ')'}
            </span>
          </Chip>
        ) : (
          <AssigneeChip
            compact={compact}
            key={userChip.userId}
            chip={userChip}
            step={type === 'progressive' ? 1 : 100}
            task={task}
            onChangeProgress={onChangeProgress}
            canChangeProgress={
              userChip.userId === thisUserId
                ? (canChangeSelfProgress ?? canChangeProgress)
                : canChangeProgress
            }
            readonlyDescription={
              task?.lockMark
                ? assignmentMessages.progressChangingIsLocked
                : task?.draft
                  ? assignmentMessages.progressChangeNotAvailableOnDraftTask
                  : assignmentMessages.onlyVerifierCanMark
            }
            showFields={showTaskFields}
            disablePopover={disablePopover}
            permission={permission}
            style={{}}
            onSetAssingmentHistory={onSetAssignmentHistory}
            enablePopover={
              assigneeIdToShow !== null && assigneeIdToShow === userChip.userId
            }
            onSetAssigneeIdToShow={onSetAssigneeIdToShow}
          />
        );
      })}
      {!singleChoice && !disable && (
        <EditIcon onClick={onFocus}>
          <Icon type={values.length ? 'edit-2' : 'plus'} color={exactWhite} />
          {emphasizeSelect && <span>{emphasizeSelect}</span>}
        </EditIcon>
      )}
    </div>
  ) : (
    <div style={{ display: 'flex' }}>
      <Popover
        trigger={trigger ? trigger : 'hover'}
        overlay={
          <div
            style={{
              maxWidth: '50vw',
              backgroundColor: 'var(--exact-white)',
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              padding: '0.5rem',
            }}
          >
            {values.map(
              (chip?: IUserOption | IRoleOption | IProjectMemberOption) => {
                const userChip = chip as IUserOption;
                return (
                  <AssigneeChip
                    compact={false}
                    key={userChip.userId}
                    chip={userChip}
                    step={type === 'progressive' ? 1 : 100}
                    task={task}
                    onChangeProgress={onChangeProgress}
                    canChangeProgress={
                      userChip.userId === thisUserId
                        ? (canChangeSelfProgress ?? canChangeProgress)
                        : canChangeProgress
                    }
                    showFields={showTaskFields}
                    disablePopover={disablePopover}
                    permission={permission}
                    onSetAssingmentHistory={onSetAssignmentHistory}
                    enablePopover={false}
                    onSetAssigneeIdToShow={onSetAssigneeIdToShow}
                  />
                );
              }
            )}
          </div>
        }
      >
        <div>
          <Chip ref={ref} hasProgress={hasProgress} showPointer={true}>
            <span>{messages.persons(values.length)}</span>
            {hasProgress && task && (
              <ChipProgress progress={sum / values.length}>
                {task.type === 'atOnce' && (
                  <span>
                    <span>
                      {convertNumbersToProperFormat(sum / 100, 0) + ' '}
                    </span>
                    {task.assigneeCompleteTitle ? (
                      task.assigneeCompleteTitle
                    ) : (
                      <Icon type="check-circle" />
                    )}
                  </span>
                )}
                {task.type === 'progressive' && (
                  <span>{`${convertNumbersToProperFormat(sum / total, 1)}%`}</span>
                )}
              </ChipProgress>
            )}
          </Chip>
        </div>
      </Popover>
    </div>
  );
};

const mapStateToProps: MapStateToProps<IStateToProps, IOwnProps, RootState> = (
  state
) => {
  const thisUserId = Number(state.thisUser.userId);
  return { thisUserId };
};

export default connect(mapStateToProps)(TaskUserList);
